import Swal from 'sweetalert2'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { showAlertLoading, showError } from '../../../../../../../_metronic/helpers'
import { Button, TableSelectionBar, useToast } from '../../../../../../components'
import { signAsoLote } from '../../core/_request'
import { AssinaturaLoteDto } from '../../core/_models'
import { useCertificado } from '../../../../../../helpers/hooks/useCertificado'

const asos = (n: number) => `${n} ${n === 1 ? 'ASO' : 'ASOs'}`

export const SignAsoListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const { refetch } = useQueryResponse()
  const { showToast } = useToast()
  const { ensurePassword } = useCertificado()
  const count = selected.length

  // A senha do certificado já é a confirmação da assinatura (ensurePassword).
  const handleSign = async () => {
    const { ok, tipo } = await ensurePassword()
    if (!ok || !tipo) return

    const assinaturaLote: AssinaturaLoteDto = {
      atendimentos: selected.map((id) => Number(id)),
      tipo,
    }

    try {
      showAlertLoading()
      const resultado = await signAsoLote(assinaturaLote)
      Swal.close()

      // Lote pode assinar parte e falhar parte: o toast diz quantos de cada.
      const erros = resultado?.numErros ?? 0
      const assinados = resultado?.numAssinados ?? count - erros
      showToast(
        erros > 0
          ? {
              variant: 'warning',
              title: `${asos(assinados)} assinado(s), ${asos(erros)} com erro.`,
              description: 'Os que falharam continuam na lista para assinar de novo.',
            }
          : { variant: 'success', title: `${asos(assinados)} assinado(s).` }
      )
      clearSelected()
      refetch()
    } catch (error) {
      showError(error)
      refetch()
    }
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <Button className='btn-primary' onClick={handleSign}>
        {count === 1 ? 'Assinar ASO' : `Assinar ${count} ASOs`}
      </Button>
    </TableSelectionBar>
  )
}
